import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_ctx.ifShowTab == true)
    ? (_openBlock(), _createBlock(_component_a_tabs, {
        key: 0,
        class: "base-frame",
        activeKey: _ctx.tabsValue,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabsValue) = $event)),
        type: "editable-card",
        hideAdd: true,
        onEdit: _ctx.onEdit
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createBlock(_component_a_tab_pane, {
              key: tab.key,
              tab: tab.title,
              closable: true
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(tab.component)))
              ]),
              _: 2
            }, 1032, ["tab"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["activeKey", "onEdit"]))
    : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dnyComponent), { key: 1 }))
}